/**
 * TanStack Query hooks for `igaming-player-ltv-per-affiliate`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingPlayerLtvPerAffiliateQueryKeys,
	type CreateIgamingPlayerLtvPerAffiliateBody,
	type ListIgamingPlayerLtvPerAffiliateResponse,
	type IgamingPlayerLtvPerAffiliateRow,
} from "./api";

export function useIgamingPlayerLtvPerAffiliateList(): UseQueryResult<ListIgamingPlayerLtvPerAffiliateResponse, Error> {
	return useQuery({
		queryKey: igamingPlayerLtvPerAffiliateQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingPlayerLtvPerAffiliateCreate(): UseMutationResult<IgamingPlayerLtvPerAffiliateRow, Error, CreateIgamingPlayerLtvPerAffiliateBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPlayerLtvPerAffiliateQueryKeys.all });
		},
	});
}

export function useIgamingPlayerLtvPerAffiliateDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPlayerLtvPerAffiliateQueryKeys.all });
		},
	});
}
